import { extractMentionLabelsPlain } from "./mentions/mentionFormatUtils";

function stripMarkdownSyntax(value: string): string {
  return value
    // Convert markdown links to plain text labels.
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, "$1")
    // Remove heading markers.
    .replace(/(^|\s)#{1,6}(?=\s)/g, " ")
    // Remove blockquote markers.
    .replace(/(^|\s)>(?=\s)/g, " ")
    // Remove inline markdown formatting delimiters.
    .replace(/(\*\*|__|\*|_|~~|`)/g, "")
    .replace(/\s+/g, " ");
}

export function sanitizeChatTitleForDisplay(title: string | null | undefined): string {
  const normalized = stripMarkdownSyntax(extractMentionLabelsPlain((title ?? "").trim())).trim();
  return normalized || "Untitled Chat";
}
